import api from "../../../api";
import { PUBLIC_ROUTES } from "../../../routes";
import urls from "../../../urls";
import type { RefreshSuccess } from "./login";

let pendingRefresh: Promise<boolean> | null = null;

export const refresh = () => {
  if (pendingRefresh) {
    return pendingRefresh;
  }

  pendingRefresh = refreshToken().finally(() => {
    pendingRefresh = null;
  });

  return pendingRefresh;
};

async function refreshToken() {
  try {
    const {
      data: { access }
    } = await api.publicRequest<RefreshSuccess>("POST", urls.auth.refresh());

    api.setAccessToken(access);

    return true;
  } catch (e) {
    if (e.code && e.code !== "ERR_NETWORK") {
      location.replace(
        `${PUBLIC_ROUTES.login}?next=${encodeURIComponent(location.pathname)}`
      );
    }

    return false;
  }
}
